// extracted by mini-css-extract-plugin
module.exports = {"press":"_211iqOXktk0zxiTrb_bZ6A"};